import {
  REDUCER_IS_LOADING_PREFIX,
  REDUCER_HAS_ERRORED_PREFIX,
  REDUCER_SUCCESS_PREFIX,
  REDUCER_NOW_NEXT,
  REDUCER_PROG,
  REDUCER_CATCHUP_DAYS,
  REDUCER_SEARCH_RESULTS,
  REDUCER_SEARCH_KEYWORD,
  REDUCER_AZ_LETTERS,
  REDUCER_AZ_PROGRAMMES,
  REDUCER_CATEGORIES,
  REDUCER_CATEGORIES_HOME,
  REDUCER_CATEGORIES_DATA,
  REDUCER_EXTRA_FEED_HOME,
  REDUCER_EXTRA_FEED_DAY,
  REDUCER_EXTRA_FEED,
  REDUCER_PROMO,
  REDUCER_CATCHUP_DAY,
  REDUCER_CATCHUP_FEATURE,
  REDUCER_IMG_OVERRIDE,
  REDUCER_PODCASTS,
  REDUCER_WATCHING,
  REDUCER_MY_LIST,
  REDUCER_CHECK_EMAIL,
  REDUCER_BROADCAST_SMART_PIN,
  REDUCER_PROCESS_SMART_PIN,
  REDUCER_RESET_PREFIX,
  REDUCER_PROFILES,
  REDUCER_CYSILL_SEARCH,
  REDUCER_CATEGORY_CONTENT,
  REDUCER_SEARCH_MAPPING,
  REDUCER_TECH_MESSAGE,
  REDUCER_CHANNELS,
  REDUCER_BOXSETS,
  REDUCER_HOME,
  REDUCER_PROG_AVAIL,
  REDUCER_COMBINED_PROG_LOAD,
  REDUCER_CAT_PROGRAMME_ROWS_DATA,
  REDUCER_AVATARS,
  REDUCER_POPULAR,
  REDUCER_TRENDING,
  REDUCER_TOP_PICKS,
  REDUCER_MORE_LIKE,
} from '../constants';

// Now and Next
export const FETCH_NOW_NEXT_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_NOW_NEXT}`;
export const FETCH_NOW_NEXT_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_NOW_NEXT}`;
export const FETCH_NOW_NEXT = `${REDUCER_SUCCESS_PREFIX}${REDUCER_NOW_NEXT}`;

// Programme
export const FETCH_PROG_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_PROG}`;
export const FETCH_PROG_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_PROG}`;
export const FETCH_PROG = `${REDUCER_SUCCESS_PREFIX}${REDUCER_PROG}`;

//Catchup days
export const FETCH_CATCHUP_DAYS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATCHUP_DAYS}`;
export const FETCH_CATCHUP_DAYS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATCHUP_DAYS}`;
export const FETCH_CATCHUP_DAYS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATCHUP_DAYS}`;

//Search
export const SEARCH_KEYWORD_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_SEARCH_KEYWORD}`;
export const SEARCH_KEYWORD_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_SEARCH_KEYWORD}`;
export const SEARCH_KEYWORD = `${REDUCER_SUCCESS_PREFIX}${REDUCER_SEARCH_KEYWORD}`;
export const SEARCH_RESULTS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_SEARCH_RESULTS}`;
export const SEARCH_RESULTS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_SEARCH_RESULTS}`;
export const SEARCH_RESULTS_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_SEARCH_RESULTS}`;

export const SEARCH_CATEGORY_CONTENT_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATEGORY_CONTENT}`;
export const SEARCH_CATEGORY_CONTENT_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATEGORY_CONTENT}`;
export const SEARCH_CATEGORY_CONTENT = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATEGORY_CONTENT}`;

// AZ
export const AZ_LETTERS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_AZ_LETTERS}`;
export const AZ_LETTERS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_AZ_LETTERS}`;
export const FETCH_AZ_LETTERS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_AZ_LETTERS}`;
export const AZ_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_AZ_PROGRAMMES}`;
export const AZ_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_AZ_PROGRAMMES}`;
export const AZ_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_AZ_PROGRAMMES}`;

// Categories
export const FETCH_CATEGORIES_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATEGORIES}`;
export const FETCH_CATEGORIES_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATEGORIES}`;
export const FETCH_CATEGORIES = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATEGORIES}`;
export const FETCH_HOME_CATEGORIES_LIST = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATEGORIES_HOME}`;
export const FETCH_HOME_CATEGORIES_LIST_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATEGORIES_HOME}`;
export const FETCH_HOME_CATEGORIES_LIST_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATEGORIES_HOME}`;
export const CAT_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATEGORIES_DATA}`;
export const CAT_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATEGORIES_DATA}`;
export const CAT_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATEGORIES_DATA}`;

//Extra Feeds
export const EXTRAFEED_DAY_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_EXTRA_FEED_DAY}`;
export const EXTRAFEED_DAY_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_EXTRA_FEED_DAY}`;
export const EXTRAFEED_DAY_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_EXTRA_FEED_DAY}`;
export const EXTRAFEED_HOME_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_EXTRA_FEED_HOME}`;
export const EXTRAFEED_HOME_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_EXTRA_FEED_HOME}`;
export const EXTRAFEED_HOME_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_EXTRA_FEED_HOME}`;
export const EXTRAFEED_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_EXTRA_FEED}`;
export const EXTRAFEED_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_EXTRA_FEED}`;
export const EXTRAFEED_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_EXTRA_FEED}`;

//Promotional Areas
export const PROMO_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_PROMO}`;
export const PROMO_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_PROMO}`;
export const PROMO_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_PROMO}`;

//CatchUp
export const CATCHUP_DAY_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATCHUP_DAY}`;
export const CATCHUP_DAY_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATCHUP_DAY}`;
export const FETCH_CATCHUP_DAY = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATCHUP_DAY}`;
export const CATCHUP_FEATURE_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CATCHUP_FEATURE}`;
export const CATCHUP_FEATURE_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CATCHUP_FEATURE}`;
export const FETCH_CATCHUP_FEATURE = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CATCHUP_FEATURE}`;

//Img Override - for Boxsets
export const IMG_OVERRIDE_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_IMG_OVERRIDE}`;
export const IMG_OVERRIDE_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_IMG_OVERRIDE}`;
export const IMG_OVERRIDE_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_IMG_OVERRIDE}`;

//Podcasts
export const PODCASTS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_PODCASTS}`;
export const PODCASTS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_PODCASTS}`;
export const PODCASTS_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_PODCASTS}`;

//Watching
export const WATCHING_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_WATCHING}`;
export const WATCHING_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_WATCHING}`;
export const WATCHING_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_WATCHING}`;

//My List
export const FETCH_ADDTOLIST_ERROR = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_MY_LIST}`;
export const FETCH_ADDTOLIST_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_MY_LIST}`;
export const FETCH_ADDTOLIST = `${REDUCER_SUCCESS_PREFIX}${REDUCER_MY_LIST}`;

//Profiles
export const PROFILES_ERROR = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_PROFILES}`;
export const PROFILES_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_PROFILES}`;
export const PROFILES_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_PROFILES}`;

//Search Category Mapping
export const SEARCH_MAPPING_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_SEARCH_MAPPING}`;
export const SEARCH_MAPPING_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_SEARCH_MAPPING}`;
export const SEARCH_MAPPING_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_SEARCH_MAPPING}`;

//export const PROFILES_SUCCESS = 'profiles_success';
//export const PROFILES_ERROR = 'profiles_error';

// MyS4C
export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';
export const RESET_USER_DATA = 'reset_user_data';
export const UNAUTH_USER_ERROR = 'unauth_user_error';
export const AUTH_ERROR = 'auth_error';
export const USER_SIGNUP_SUCCESS = 'user_signup_success';
export const USER_SIGNUP_ERROR = 'auth_signup_error';
export const USER_VERIFY_SUCCESS = 'user_verify_success';
export const USER_VERIFY_ERROR = 'user_verify_error';
export const USER_DATA_ERROR = 'user_data_error';
export const USER_DATA_SUCCESS = 'user_data_success';
export const USER_DATA_UPDATE_SUCCESS = 'user_data_update_success';
export const DELETE_USER_SUCCESS = 'delete_user_success';

export const EMAIL_CHANGE_SUCCESS = 'email_change_success';
export const EMAIL_CHANGE_ERROR = 'email_change_error';
export const EMAIL_VERIFY_SUCCESS = 'email_verify_success';
export const EMAIL_VERIFY_ERROR = 'email_verify_error';
export const CHANGE_PWORD_SUCCESS = 'change_pword_success';
export const CHANGE_PWORD_ERROR = 'change_pword_error';
export const CHANGE_PWORD_LOGEDIN_SUCCESS = 'change_pword_logedin_success';
export const CHANGE_PWORD_LOGEDIN_ERROR = 'change_pword_logedin_error';
export const FORGOT_PWORD_SUCCESS = 'forgot_pword_success';
export const FORGOT_PWORD_ERROR = 'forgot_pword_error';
export const GET_MAIL = 'get_email';

// Cysill Search
export const CYSILL_SEARCH_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CYSILL_SEARCH}`;
export const CYSILL_SEARCH_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CYSILL_SEARCH}`;
export const CYSILL_SEARCH_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CYSILL_SEARCH}`;

// Email verification
export const CHECK_EMAIL_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CHECK_EMAIL}`;
export const CHECK_EMAIL_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CHECK_EMAIL}`;
export const CHECK_EMAIL_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CHECK_EMAIL}`;

// Programme Page
export const SERIES_FETCH_DATA_SUCCESS = 'series_fetch_data_sucess';
export const SERIES_IS_LOADING = 'series_is_loading';
export const SERIES_HAS_ERRORED = 'series_has_errored';

// Favourites
export const FETCH_FAVOURITES = 'fetch_favourites';
export const ADD_FAVOURITES = 'add_favourites';
export const REMOVE_FAVOURITES = 'remove_favourites';

//Add To list
export const ADD_ADDTOLIST = 'add_add_to_list';
export const ADD_ADDTOLIST_ERROR = 'add_addtolist_error';
export const REMOVE_ADDTOLIST = 'remove_add_to_list';
export const REMOVE_ADDTOLIST_ERROR = 'remove_add_to_list_error';

//Language
export const SWITCH_LANGUAGE = 'switch_language';
export const FETCH_LANGUAGE = 'fetch_language';

// Side Nav
export const FETCH_SIDE_NAV = 'fetch_side_nav';
export const SET_SIDE_NAV = 'set_side_nav';

// Categories
export const FETCH_HOME_CATEGORIES = 'fetch_home_categories';
export const FETCH_HOME_CATEGORIES_IS_LOADING =
  'fetch_home_categories_is_loading';
export const FETCH_HOME_CATEGORIES_HAS_ERRORED =
  'fetch_home_categories_has_errored';

//Autoplay Next
export const FETCH_AUTO_NEXT = 'fetch_auto_next';
export const SET_AUTO_NEXT = 'set_auto_next';

//ParentControl
export const FETCH_PC = 'fetch_parent_controls';
export const FETCH_PC_ERROR = 'fetch_parent_controls_error';
export const SET_PC = 'set_parent_controls';
export const UPDATE_PC_STATUS = 'update_pc_status';
export const UPDATE_PC_PIN = 'update_pc_pin';
export const UPDATE_PC_PIN_ERROR = 'update_pc_pin_error';
export const VERIFY_PC_PIN = 'check_pc_pin';
export const VERIFY_PC_PIN_ERROR = 'check_pc_pin_error';
export const DISABLE_PC_PIN = 'disable_pc_pin';
export const DISABLE_PC_PIN_ERROR = 'disable_pc_pin_error';

//Adverts
export const ADVERTS_HAS_ERRORED = 'adverts_has_errored';
export const ADVERTS_IS_LOADING = 'adverts_is_loading';
export const ADVERTS_STING_SERIES_FETCH_DATA_SUCCESS =
  'adverts_sting_series_fetch_data_success';
export const ADVERTS_STING_PROGRAMME_FETCH_DATA_SUCCESS =
  'adverts_sting_programme_fetch_data_success';
export const ADVERTS_DISABLE_FETCH_DATA_SUCCESS =
  'adverts_disable_fetch_data_success';
export const ADVERTS_STING_CAT_FETCH_DATA_SUCCESS =
  'adverts_sting_cat_fetch_data_success';

// Tech Message
export const TECH_MESSAGE_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_TECH_MESSAGE}`;
export const TECH_MESSAGE_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_TECH_MESSAGE}`;
export const TECH_MESSAGE_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_TECH_MESSAGE}`;

//Mailing Lists
export const MAIL_LISTS_SUCCESS = 'mail_lists_success';
export const MAIL_LISTS_ERROR = 'mail_lists_error';
export const UPDATE_MAIL_LISTS_SUCCESS = 'update_mail_lists_success';
export const UPDATE_MAIL_LISTS_ERROR = 'update_mail_lists_error';

//Profiles
export const SET_PROFILE_SUCCESS = 'set_profile_success';
export const SET_PROFILE_ERROR = 'set_profile_error';
export const PROFILE_DATA_SUCCESS = 'profile_data_success';
export const PROFILE_DATA_ERROR = 'profile_data_error';
export const PROFILE_DATA_UPDATE_SUCCESS = 'profile_data_update_success';
export const PROFILE_DATA_UPDATE_ERROR = 'profile_data_error';
export const PROFILE_DELETE_SUCCESS = 'profile_delete_success';
export const PROFILE_DELETE_ERROR = 'profile_delete_error';
export const PROFILE_NAME = 'profile_name';
export const PROFILE_ID = 'profile_id';
export const PROFILE_IS_CHILD = 'profile_is_child';
export const PROFILE_ACTIVE_UPDATE = 'profile_active_update';

//Programme Resume
export const PROG_RESUME_HAS_ERRORED = 'prog_resume_has_errored';
export const PROG_RESUME_IS_LOADING = 'prog_resume_is_loading';
export const PROG_RESUME_FETCH_DATA_SUCCESS = 'prog_resume_fetch_data_success';

// Process smart pin
export const SMART_TV_PROCESS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_PROCESS_SMART_PIN}`;
export const SMART_TV_PROCESS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_PROCESS_SMART_PIN}`;
export const SMART_TV_PROCESS_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_PROCESS_SMART_PIN}`;
export const SMART_TV_PROCESS_RESET = `${REDUCER_RESET_PREFIX}${REDUCER_PROCESS_SMART_PIN}`;

// Broadcast processed pin
export const SMART_TV_BROADCAST_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_BROADCAST_SMART_PIN}`;
export const SMART_TV_BROADCAST_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_BROADCAST_SMART_PIN}`;
export const SMART_TV_BROADCAST_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_BROADCAST_SMART_PIN}`;
export const SMART_TV_BROADCAST_RESET = `${REDUCER_RESET_PREFIX}${REDUCER_BROADCAST_SMART_PIN}`;

//Login Redirect
export const LOGIN_REDIRECT = 'login_redirect';

//Channels
export const CHANNELS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CHANNELS}`;
export const CHANNELS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CHANNELS}`;
export const CHANNELS_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CHANNELS}`;

//Boxsets
export const BOXSETS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_BOXSETS}`;
export const BOXSETS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_BOXSETS}`;
export const BOXSETS_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_BOXSETS}`;

//Homepage
export const HOME_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_HOME}`;
export const HOME_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_HOME}`;
export const HOME_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_HOME}`;
// Programme
export const FETCH_PROG_AVAIL_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_PROG_AVAIL}`;
export const FETCH_PROG_AVAIL_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_PROG_AVAIL}`;
export const FETCH_PROG_AVAIL = `${REDUCER_SUCCESS_PREFIX}${REDUCER_PROG_AVAIL}`;

export const COMBINED_PROG_LOAD_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_COMBINED_PROG_LOAD}`;
//Category Programme Rows
export const CAT_PROG_ROWS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_CAT_PROGRAMME_ROWS_DATA}`;
export const CAT_PROG_ROWS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_CAT_PROGRAMME_ROWS_DATA}`;
export const CAT_PROG_ROWS_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_CAT_PROGRAMME_ROWS_DATA}`;

//Avatars
export const AVATARS_HAS_ERRORED = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_AVATARS}`;
export const AVATARS_IS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_AVATARS}`;
export const AVATARS_FETCH_DATA_SUCCESS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_AVATARS}`;

//Popular
export const FETCH_POPULAR_ERROR = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_POPULAR}`;
export const FETCH_POPULAR_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_POPULAR}`;
export const FETCH_POPULAR = `${REDUCER_SUCCESS_PREFIX}${REDUCER_POPULAR}`;

//Trending
export const FETCH_TRENDING_ERROR = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_TRENDING}`;
export const FETCH_TRENDING_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_TRENDING}`;
export const FETCH_TRENDING = `${REDUCER_SUCCESS_PREFIX}${REDUCER_TRENDING}`;

//Top pics
export const FETCH_TOP_PICKS_ERROR = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_TOP_PICKS}`;
export const FETCH_TOP_PICKS_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_TOP_PICKS}`;
export const FETCH_TOP_PICKS = `${REDUCER_SUCCESS_PREFIX}${REDUCER_TOP_PICKS}`;

//More like
export const FETCH_MORE_LIKE_ERROR = `${REDUCER_HAS_ERRORED_PREFIX}${REDUCER_MORE_LIKE}`;
export const FETCH_MORE_LIKE_LOADING = `${REDUCER_IS_LOADING_PREFIX}${REDUCER_MORE_LIKE}`;
export const FETCH_MORE_LIKE = `${REDUCER_SUCCESS_PREFIX}${REDUCER_MORE_LIKE}`;
